module.exports = __webpack_public_path__ + "static/media/tableRound.8b03baba.png";